import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { TCITooltip } from '@/components/ui/Tooltip';
import Icon from '@/components/ui/Icon';
import PrintButton from '../PrintButton';
import styles from './index.module.scss';

const PrintPdf = ({ comingSoon, pdfPath, tooltipText }) => {
  if (comingSoon) {
    const label = I18n.t('print_coming_soon');

    return (
      <TCITooltip side="bottom">
        <TCITooltip.Trigger asChild>
          <button aria-disabled className={`${styles.icon} ${styles.comingSoon}`} type="button">
            <Icon className={styles.disabled} icon="Print" size={30} />
            <span className="sr-only">{label}</span>
          </button>
        </TCITooltip.Trigger>
        <TCITooltip.Content>{label}</TCITooltip.Content>
      </TCITooltip>
    );
  }

  return (
    <span className={styles.icon}>
      <PrintButton
        pdfPath={pdfPath}
        placement="bottom"
        tooltipText={tooltipText}
        wrapperClass="shortcutPrintButton"
      />
    </span>
  );
};

PrintPdf.propTypes = {
  comingSoon: PropTypes.bool,
  pdfPath: PropTypes.string,
  tooltipText: PropTypes.string
};

PrintPdf.defaultProps = {
  comingSoon: false,
  pdfPath: undefined,
  tooltipText: undefined
};

export default PrintPdf;
